const Product = {
    id: '',
    name: '',
    amount: ''
};

export default Product;